export default "__VITE_ASSET__DbLwTWJz__"